import {ColDef, ColGroupDef} from 'ag-grid-community';

/**
 * Check if a passed variable is a function
 */
export const isCallable = (func: any): func is Function => func && typeof func === 'function';

export const isStringArray = (arg: any): arg is string[] => {
	if (!Array.isArray(arg)) {return false;}

	if (arg.length === 0) {return false;};

	return arg.every(item => typeof item === 'string');
};

export function isDefined<TValue>(value: TValue | null | undefined): value is TValue {
	return (value !== null && value !== undefined);
}

export function hasValue(input: any): input is {value: any} {
	return input?.hasOwnProperty('value');
}

export function isValidOption(input: any): input is {value: any, label: string} {
	return input?.hasOwnProperty('value') &&
	input?.hasOwnProperty('label') &&
	typeof input.label === 'string' &&
	input.label !== null &&
	input.label !== undefined;
}

export function isGroupColDef(input: (ColGroupDef | ColDef)): input is ColGroupDef {
	return input.hasOwnProperty('children');
}
